import { render, staticRenderFns } from "./EventListDay.vue?vue&type=template&id=3485203a&scoped=true"
import script from "./EventListDay.vue?vue&type=script&lang=js"
export * from "./EventListDay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3485203a",
  null
  
)

export default component.exports